// React
import { Fragment, ReactElement } from 'react';
// Design System
import { Skeleton } from '@utmb/design-system/placeholder/Placeholder';
// Styles
import styles from './dashboard-skeleton.module.scss';

const DashboardSkeleton = (): ReactElement => {
    return (
        <ul className={styles.skeleton}>
            <li className={styles.skeleton_dashboard_header}>
                <div className={styles.left}>
                    <div>
                        <Skeleton className={styles.skeleton_name} width="75%" height="36" />
                        <Skeleton width="60%" height="16" />
                    </div>
                    <ul className={styles.skeleton_modal}>
                        {[...new Array(3)].map((v, i) => (
                            <li key={i} className={styles.skeleton_modal_button}>
                                <Skeleton width="100%" height="90" />
                            </li>
                        ))}
                    </ul>
                </div>
                <div className={styles.right}>
                    <Skeleton width="100%" height="244" />
                </div>
            </li>
            {[...new Array(2)].map((v, i) => (
                <Fragment key={i}>
                    <li className={styles.skeleton_dashboard_separator}>
                        <Skeleton width="20%" height="18" />
                        <Skeleton className={styles.skeleton_separator_link} width="15%" height="50" />
                    </li>
                    <li className={styles.skeleton_dashboard_achievements}>
                        <ul className={styles.skeleton_achievements_list}>
                            {[...new Array(2)].map((v, j) => (
                                <li key={j} className={styles.skeleton_achievements_item}>
                                    <div className={styles.skeleton_image_card}>
                                        <Skeleton width="100%" height="200" />
                                    </div>
                                    <div className={styles.skeleton_achievements_content}>
                                        <Skeleton className={styles.skeleton_city_name} width="60%" height="36" />
                                        <ul className={styles.skeleton_stats_container}>
                                            {[...new Array(4)].map((v, k) => (
                                                <li key={k} className={styles.skeleton_stats_item}>
                                                    <Skeleton className={styles.skeleton_stat_label} width="50%" height="14" />
                                                    <Skeleton width="75%" height="22" />
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </li>
                </Fragment>
            ))}
        </ul>
    );
};

export default DashboardSkeleton;
